# SMA Endpoint Directory

Track which state Medicaid agencies have implemented FHIR-based patient access and provider directory APIs.

## Overview

The SMA Endpoint Directory API provides access to the CMS [State Medicaid Agency Endpoint Directory](https://github.com/CMSgov/SMA-Endpoint-Directory) — a dataset that tracks FHIR endpoint implementations across all 50 U.S. states, the District of Columbia, and 5 territories (56 entities total).

Under the CMS Interoperability and Patient Access rule, state Medicaid agencies must implement FHIR-based APIs for patient access to claims, formulary, and provider directory data. This API lets you programmatically check which states have implemented these APIs, what vendors they use, and where the endpoints are.

## Use Cases

- **Interoperability monitoring** — Track state-by-state Medicaid FHIR implementation progress
- **App development** — Discover production FHIR endpoint URLs for Medicaid patient access APIs
- **Vendor analysis** — Understand which EHR vendors power state Medicaid FHIR implementations
- **Compliance reporting** — Generate reports on CMS mandate compliance across states

## Endpoints

| Method | Path | Description |
|--------|------|-------------|
| GET | `/v1/sma/states` | List all states with implementation status |
| GET | `/v1/sma/states/:state` | Get full endpoint details for a specific state |
| GET | `/v1/sma/stats` | Get aggregate statistics across all states |

## Data Source

| Dataset | Source | Update Frequency |
|---------|--------|-----------------|
| SMA Endpoint Directory | [CMS / GitHub](https://github.com/CMSgov/SMA-Endpoint-Directory) | Monthly (survey-based) |

All data is **public domain** — no licensing restrictions on use.

## Required Scopes

- `connectivity.read` — All SMA endpoints (shared with the [Connectivity API](/docs/connectivity/overview))

## Pages in This Section

- [API Reference](/docs/sma/api-reference) — Detailed request/response examples for all 3 endpoints

## See Also

- [Connectivity Intelligence](/docs/connectivity/overview) — Look up FHIR endpoints for individual providers by NPI
